export default "__VITE_ASSET__Ca1wikM1__"